import Cookies from "js-cookie";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { updateProfile } from "../redux/actions/profile";
import Api from "../api/newApi";
import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { Redirect } from "react-router-dom/cjs/react-router-dom";
const Middleware = ({ children }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const layout = useSelector((state) => state.layout);
  const [error, setError] = useState("");
  const query = new URLSearchParams(useLocation().search);
  const loadercss = `
.loader {
  border: 4px solid #C3CCE0; /* bg */
  border-top: 4px solid #00c19f; /* rotating border */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s cubic-bezier(0.6, 0.2, 0.4, 0.8) infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% { transform: translate(-50%, -50%) rotate(0deg); }
  100% { transform: translate(-50%, -50%) rotate(360deg); }
}`;

  const login = () => {
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("token");
    Cookies.remove("refreshToken");
    const paramsArray = Array.from(query.keys());
    const service =
      paramsArray.find((item) => item.toLowerCase() === "servicetype") ||
      paramsArray.find((item) => item.toLowerCase() === "serviceid");
    const serviceType =
      query.get(service) === "10001" ? "school" : query.get(service);
    Api.Post("user/service/shahrzad", {
      text: query.get("token"),
      service: serviceType,
      url: window.location.href,
    })
      .then((res) => {
        if (res.data.Code === 200) {
          console.log("login response", res);
          handleAfterLogin(res.data.Data);
        }
      })
      .catch((err) => {
        setError(err?.response?.data?.Message + "");
      });
  };

  const handleAfterLogin = (response) => {
    if (
      location &&
      location.pathname !== "/school/parent/students" &&
      location.pathname !== "/paths" &&
      !Cookies.get("token")
    ) {
      dispatch(updateProfile(response.profile));
      Cookies.set("token", response.token, { expires: 365 });
      Cookies.set("refreshToken", response.refreshToken, {
        expires: 365,
      });
      localStorage.setItem("agent_service", "shahrzad");
      if (response?.service === "school") {
        history.replace("/school/parent/students");
      } else if (response?.service === "survey") {
        history.replace("/survey");
      } else {
        history.replace("/paths");
      }
      // dispatch(toggleLoadingShahrzad(false));
    }
  };

  useEffect(() => {
    if (query.get("token")) {
      // dispatch(toggleLoadingShahrzad(true));
      // if (localStorage.getItem("agent_service") === "shahrzad") {
      // 	if (query.get("servicetype") === "school") {
      // 		history.replace("/school/parent/students")
      // 	} else {
      // 		// history.replace("/school/parent/students")
      // 		history.replace("/paths")
      // 	}
      // } else {
      // 	login()
      // }
      login();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.get("token")]);

  return layout.loadingShahrzad ? (
    <Stack>
      {error ? (
        <Typography variant="h4" margin={"auto"}>
          {error}
        </Typography>
      ) : (
        <>
          <style>{loadercss}</style>
          <div class="loader"></div>
        </>
      )}
    </Stack>
  ) : !Cookies.get("token") && !query.get("token") ? (
    // history.replace("/auth")
    <Redirect to="/auth" />
  ) : error === "" ? (
    <>{children}</>
  ) : (
    <>
      <style>{loadercss}</style>
      <div class="loader"></div>
    </>
  );

  // if (!Cookies.get("token") && !query.get("token")) {
  //   history.replace("/auth");
  //   return null;
  // }
  // return children;
};

export default Middleware;
